<template>
  <div id="app" style="min-height:100%;min-width:100%;">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
  }

}
</script>

<style lang="less">
</style>
